import {Mapper} from '@s-ui/domain'

export class WebPageStructuredDataSeoMapper extends Mapper {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Function} deps.structuredDataValueObjectFactory
   * */
  constructor({structuredDataValueObjectFactory}) {
    super()
    this._structuredDataValueObjectFactory = structuredDataValueObjectFactory
  }

  /**
   * https://schema.org/WebPage
   * @param {Object} params
   * @param {string} params.canonical - Canonical URL
   * @param {string} params.name - Page title
   * @return {StructuredDataValueObject}
   */
  map = ({canonical, name}) => {
    if (!canonical || !name) return null

    const webPageSchema = {
      '@type': 'WebPage',
      '@id': `${canonical}#webpage`,
      url: canonical,
      name,
      breadcrumb: {
        '@id': `${canonical}#breadcrumb`
      }
    }

    return this._structuredDataValueObjectFactory(webPageSchema)
  }
}
